module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="verticalOpenOptions">Options</div>\n<div class="verticalCloseOptions">Fermer</div>\n<div class="openTriangle"></div>\n<div class="closeTriangle"></div>\n<div class="options">\n    <h3>Affichage</h3>\n        <div class="calendarDisplay">\n            <label class="rad">\n              <input type="radio" name="calendarDisplay" value="agenda" checked>Agenda</input>\n            </label>\n            <label class="rad">\n              <input type="radio" name="calendarDisplay" value="hist">Historique</input>\n            </label>\n        </div>\n</div>';

}
return __p
}